import { useTranslation } from 'react-i18next';
import { SelectableTableColumn } from '../../components/SelectableTable/SelectableTable.types';

export const useSampleAssessmentColumns = () => {
  const { t } = useTranslation();

  const columns: SelectableTableColumn[] = [
    {
      id: 'RGZid',
      type: 'checkbox',
      title: '',
      filterType: null,
      sortable: true,
    },
    {
      id: 'lastName',
      type: 'text',
      title: t('sampleAssessment:table.examiner'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'examTaskGroupSolutionScoreId',
      type: 'link',
      title: t('sampleAssessment:table.examTaskGroupSolutionScoreId'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'schoolId',
      type: 'text',
      title: t('sampleAssessment:table.schoolId'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'processType',
      type: 'text',
      title: t('sampleAssessment:table.processType'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'pointSum',
      type: 'text',
      title: t('sampleAssessment:table.pointSum'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'progress',
      type: 'text',
      title: t('sampleAssessment:table.progress'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'alerts',
      type: 'text',
      title: t('sampleAssessment:table.alerts'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'acceptanceStatus',
      type: 'text',
      title: t('sampleAssessment:table.acceptanceStatus'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'updateDate',
      type: 'date',
      title: t('sampleAssessment:table.updateDate'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'actions',
      type: 'text',
      title: 'Akcje',
      filterType: null,
      skipEnterMethod: true,
    },
  ];

  return { columns };
};
